"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function SaphanaGreenMultitoneFilled(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#FF730E",
    d: "M0 15.889h9.6L16 7H0v8.889z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9549",
    d: "M0 15.889h5.448L11.556 7H0v8.889z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF730E",
    d: "M1.835 6c-.425 0-.785-.072-1.08-.215A2.518 2.518 0 010 5.217l.693-.699c.327.37.731.554 1.211.554.259 0 .45-.053.575-.16a.527.527 0 00.187-.422.498.498 0 00-.11-.332c-.074-.092-.225-.155-.45-.187l-.479-.062C1.115 3.844.74 3.689.5 3.445.263 3.2.145 2.875.145 2.468c0-.217.042-.415.125-.595.083-.18.2-.335.353-.464.157-.13.347-.229.568-.298.226-.074.483-.111.769-.111.365 0 .685.058.962.173.277.116.515.284.714.506l-.7.706a1.344 1.344 0 00-.422-.325 1.283 1.283 0 00-.616-.132c-.236 0-.411.042-.527.125a.403.403 0 00-.173.346c0 .166.044.286.132.36.092.074.24.127.443.16l.478.075c.498.079.868.234 1.108.464.24.227.36.55.36.97a1.6 1.6 0 01-.125.637c-.083.194-.205.36-.367.499a1.68 1.68 0 01-.588.325c-.236.074-.504.111-.804.111zM7.154 5.917l-.346-1.15H5.194l-.346 1.15H3.78l1.593-4.834h1.302l1.572 4.834H7.154zM6.01 2.039h-.034l-.534 1.835h1.108l-.54-1.835zM8.501 5.917V1.083h2.286c.226 0 .429.04.61.118.18.074.332.178.456.311.13.134.229.298.298.492.07.19.104.397.104.623 0 .231-.035.441-.104.63-.07.19-.169.351-.298.485-.124.134-.277.24-.457.319-.18.074-.383.11-.61.11H9.555v1.746H8.501zm1.053-2.66h1.108c.157 0 .28-.039.367-.117.092-.083.139-.203.139-.36v-.305c0-.157-.047-.275-.139-.353a.512.512 0 00-.367-.125H9.554v1.26z"
  }));
}

SaphanaGreenMultitoneFilled.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
SaphanaGreenMultitoneFilled.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = SaphanaGreenMultitoneFilled;
exports["default"] = _default;